import { createContext, useContext, type ReactNode } from 'react';

const DEFAULT_ORCHESTRATOR_NAME = 'pay-group-payments-component-orchestrator';

interface PaySuiteConfig {
  orchestratorName: string;
}

const PaySuiteConfigContext = createContext<PaySuiteConfig>({
  orchestratorName: DEFAULT_ORCHESTRATOR_NAME,
});

export function usePaySuiteConfig(): PaySuiteConfig {
  return useContext(PaySuiteConfigContext);
}

interface PaySuiteConfigProviderProps {
  orchestratorName?: string;
  children: ReactNode;
}

export function PaySuiteConfigProvider({ orchestratorName, children }: PaySuiteConfigProviderProps): React.ReactElement {
  return (
    <PaySuiteConfigContext.Provider value={{ orchestratorName: orchestratorName ?? DEFAULT_ORCHESTRATOR_NAME }}>
      {children}
    </PaySuiteConfigContext.Provider>
  );
}
